module.exports = __webpack_public_path__ + "static/media/header-logo.80911a28.png";